import React from 'react';
import { useSelector } from 'react-redux';

import { selectedSuperBatchSelector } from 'features/classCreation';
import AddOrRemoveLearnersField from './AddOrRemoveLearnersField';
import AddOrRemoveLearnersActions from './AddOrRemoveLearnersActions';
import ConfirmModal from './ConfirmModal';
import SectionHeading from 'components/SectionHeading';
import SelectSecondaryAndCrashCourseBatch from './SelectSecondaryAndCrashCourseBatch';

export default function EditCrashCourseBatchPage() {
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);
  return (
    <>
      <SectionHeading
        title="EDIT BATCH"
        subtitle="Select batch to make changes"
      />
      <SelectSecondaryAndCrashCourseBatch />
      {selectedSuperBatch && (
        <>
          <AddOrRemoveLearnersActions />
          <AddOrRemoveLearnersField />
          <ConfirmModal />
        </>
      )}
    </>
  );
}
